import "./App.css";
import MXSidebar from "./Elements/MXSidebar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Views/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import Profile from "./Views/Profile/Profile";
import RedirectHandler from "./Views/RedirectHandler";
import SecureRoute from "./Elements/SecureRoute";
import Dashboard from "./Views/Dashboard/Dashboard";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import ComplaintList from "./Views/Complaints/ComplaintsList";
import RedirectProfile from "./Views/RedirectProfileGet";
import OpportunityRoutes from "./Routes/OpportunityRoues";
import SurveyRoutes from "./Routes/SurveyRoutes";
require("typeface-poppins");
require("typeface-lato");
require("typeface-public-sans");
function App() {
  const [sideBarOn, setViewSideBar] = useState(true);
  return (
    <BrowserRouter>
      <ReactNotifications />
      <MXSidebar viewSideBar={sideBarOn}>
        <Routes>
          <Route
            path="/dashboard"
            element={<SecureRoute element={<Dashboard />} />}
          />
          <Route
            path="/complaints"
            element={<SecureRoute element={<ComplaintList />} />}
          />
          <Route path="/login" element={<Login callBack={setViewSideBar} />} />
          <Route path="/opportunities/*" element={<OpportunityRoutes />} />
          <Route path="/mx-surveys/*" element={<SurveyRoutes />} />
          <Route
            path="/redirect"
            element={<RedirectHandler callBack={setViewSideBar} />}
          />
          <Route
            path="/redirectProfile"
            element={<RedirectProfile callBack={setViewSideBar} />}
          />
          <Route
            path="/profile"
            element={<SecureRoute element={<Profile />} />}
          />
          <Route
            path="*"
            element={
              <SecureRoute element={<Login callBack={setViewSideBar} />} />
            }
          />
        </Routes>
      </MXSidebar>
    </BrowserRouter>
  );
}

export default App;
